<template>
  <div class="budget mt-3">
    <v-card class="custom_card" background="#fff">
      <v-layout>
        <!-- Section left -->
        <v-flex xs5 pr-10 style="border-right: 1px solid #d3d3d3">
          <v-layout style="gap: 10px" align-center pl-4>
            <v-flex shrink>
              <v-btn dark depressed fab color="#F9BB43" width="36" height="36">
                <Icon class="font-20" icon="majesticons:percent" />
              </v-btn>
            </v-flex>
            <v-flex>
              <div class="font-16 font-w-700">ร้อยละของการใช้งปม.</div>
              <div class="font-12">ทั้งหมด (วันนี้)</div>
            </v-flex>
            <v-spacer />
            <v-flex shrink class="font-36 font-w-700 pr-6 font-pp">
              {{ data?.budgetRate }}<span class="font-24 font-w-600">%</span>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex shrink class="gauge_chart">
              <highcharts
                v-if="isGaugeChartOptions"
                :options="gaugeChartOptions"
              ></highcharts>
              <v-layout
                justify-space-between
                mt-n6
                pr-9
                pl-14
                style="position: relative; z-index: 99"
              >
                <v-flex shrink>0%</v-flex>
                <v-flex shrink>100%</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-divider class="my-4" style="border-width: 1px" />

          <v-layout style="gap: 10px" align-center pl-4>
            <v-flex shrink>
              <v-btn dark depressed fab color="#F15A29" width="36" height="36">
                <Icon class="font-20" icon="bx:coin-stack" />
              </v-btn>
            </v-flex>
            <v-flex>
              <div class="font-16 font-w-700">งปม. ปี {{data.fiscalYear}}</div>
              <div class="font-12">ทั้งหมด</div>
            </v-flex>
            <v-spacer />
          </v-layout>
          <div
            class="text-right font-32 font-w-700 font-pp"
            style="color: #f15a29"
          >
            {{ checkFormatNummber(data.totalBudget)
            }}<span class="font-24 font-w-600">฿</span>
          </div>

          <v-divider class="my-4" style="border-width: 1px" />

          <v-layout style="gap: 10px" align-center pl-4>
            <v-flex shrink>
              <v-btn dark depressed fab color="#EE8046" width="36" height="36">
                <Icon class="font-20" icon="ri:refund-2-line" />
              </v-btn>
            </v-flex>
            <v-flex>
              <div class="font-16 font-w-700">งปม. ที่ใช้ไป</div>
              <div class="font-12">ทั้งหมด (วันนี้)</div>
            </v-flex>
            <v-spacer />
          </v-layout>
          <div
            class="text-right font-32 font-w-700 font-pp"
            style="color: #ee8046"
          >
            {{ checkFormatNummber(data.usedBudget) }}
            <span class="font-24 font-w-600">฿</span>
          </div>

          <v-divider class="my-4" style="border-width: 1px" />

          <v-layout style="gap: 10px" align-center pl-4>
            <v-flex shrink>
              <v-btn dark depressed fab color="#F7941D" width="36" height="36">
                <Icon class="font-20" icon="ri:hand-coin-line" />
              </v-btn>
            </v-flex>
            <v-flex>
              <div class="font-16 font-w-700">งปม. คงเหลือ</div>
              <div class="font-12">ทั้งหมด (วันนี้)</div>
            </v-flex>
            <v-spacer />
          </v-layout>
          <div
            class="text-right font-32 font-w-700 font-pp"
            style="color: #f15a29"
          >
            {{ checkFormatNummber(data.remainingBudget)
            }}<span class="font-24 font-w-600">฿</span>
          </div>
        </v-flex>

        <!-- Section Right -->
        <v-flex px-10 xs7 style="border-left: 1px solid #d3d3d3">
          <!-- จำนวนโครงการ -->
          <v-layout style="gap: 10px" align-center>
            <v-flex shrink>
              <v-img
                width="34"
                height="34"
                :src="require('../../assets/images/dashboard/judge.png')"
              />
            </v-flex>
            <v-flex>
              <div class="font-20 font-w-700">จำนวนโครงการ</div>
              <div class="font-16">และงบประมาณตามแผนงาน</div>
            </v-flex>
            <v-spacer />
            <v-flex shrink class="text-center pt-3">
              <v-btn
                style="border-radius: 36px"
                color="#3B608A"
                width="95px"
                height="45px"
                dark
                depressed
              >
                <span class="font-36 font-w-700 font-pp">
                  {{ data.projectAmount ? data.projectAmount : 0 }}
                </span>
              </v-btn>
              <div class="font-12 font-w-700" style="color: #3b608a">
                โครงการ
              </div>
            </v-flex>
          </v-layout>

          <div class="pl-6 mb-3">
            <!-- งบประมาณที่ได้ -->
            <v-layout
              align-center
              justify-space-between
              v-for="(plan, i) in data.plans"
              :key="i"
              class="my-2"
            >
              <v-flex xs2>
                <div class="font-10 font-w-500 text-center">งบประมาณที่ได้</div>
                <div
                  class="font-16 font-w-700 text-center font-pp"
                  style="color: #3b608a"
                >
                  {{ checkFormatNummber(plan.budgetReceived)
                  }}<span class="font-12 font-w-600">฿</span>
                </div>
              </v-flex>
              <v-flex xs1 class="text-center">
                <Icon
                  style="color: #3b608a"
                  class="font-38 pt-2"
                  icon="carbon:caret-left"
                />
              </v-flex>
              <v-flex xs9>
                <div class="font-12 font-w-700">{{ plan.nameTH }}</div>
                <div class="font-12 font-w-700">{{ plan.nameEN }}</div>
              </v-flex>
            </v-layout>

            <v-card
              color="#F5F5F5"
              flat
              class="pa-6"
              style="border-radius: 20px"
            >
              <!-- ร้อยละการใช้งบประมาณ -->
              <v-layout justify-space-between>
                <v-flex shrink>
                  <div class="font-24 font-w-700">ร้อยละการใช้งบประมาณ</div>
                  <div class="font-16 font-w-400">ตามแผนงาน</div>
                </v-flex>
                <v-spacer />
                <!-- <v-flex shrink>
                  <v-btn icon @click="showDialog()">
                    <Icon
                      style="color: #b1b1b1"
                      class="font-32"
                      icon="ant-design:fullscreen-outlined"
                    />
                  </v-btn>
                </v-flex> -->
              </v-layout>

              <v-layout justify-space-between align-center >
                <v-flex xs5>
                  <div v-for="(plan, i) in data.plans" :key="i" class="mb-3">
                    <div
                      class="font-14 font-w-700"
                      :style="{ color: plan.code }"
                    >
                      {{ plan.budgetRate }}%
                    </div>
                    <div class="font-12 font-w-700">
                      <v-tooltip bottom color="#464647" dark>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="budget_rate">
                            {{ plan.nameEN }}
                          </span>
                        </template>
                        <div class="font-10 text-center">
                          <div>{{ plan.nameTH }}</div>
                          <div>{{ plan.nameEN }}</div>
                        </div>
                      </v-tooltip>
                    </div>
                  </div>
                  
                </v-flex>
                <v-flex xs7 class="solidgauge_chart">
                  <highcharts
                    v-if="isShoSsolidgauge"
                    :options="solidgaugeChartOptions"
                  ></highcharts>
                </v-flex>
              </v-layout>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- ร้อยละการใช้งบประมาณ -->
    <v-card class="custom_card pa-6 mt-4">
      <div class="font-20 font-w-700">ร้อยละการใช้งบประมาณ</div>
      <div class="font-16 font-w-400">ตามภูมิภาค</div>

      <v-layout justify-center mt-4>
        <v-flex shrink>
          <highcharts :options="columnChartOptions"></highcharts>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog" width="800" persistent>
      <v-card
        width="800"
        height="500"
        color="#F5F5F5"
        style="position: relative"
        class="d-flex justify-center align-center"
      >
        <v-btn
          icon
          absolute
          top
          right
          style="z-index: 99"
          @click="closeDialog()"
        >
          <Icon
            class="font-32"
            style="color: #b1b1b1"
            icon="ant-design:fullscreen-exit-outlined"
          />
        </v-btn>
        <highcharts :options="solidgaugeChartOptions"></highcharts>
      </v-card>
    </v-dialog>
    <!-- 
    <pre>
      {{ columnChartOptions.series[0] }}
      {{ columnChartOptions.series[1] }}
    </pre> -->
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import hcMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import * as XLSX from "xlsx";
import moment from "moment";

hcMore(Highcharts);
solidGauge(Highcharts);
var perShapeGradient = {
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1,
};
export default {
  name: "Budget",
  props: {
    filter: {
      type: Object,
      default: () => ({
        plan_id: "",
        region_id: "",
        year: "",
      }),
    },
    exportExcel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Icon,
    highcharts: Chart,
  },
  data() {
    return {
      isGaugeChartOptions: true,
      gaugeChartOptions: {
        chart: {
          type: "gauge",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          width: 372,
          height: 372,
        },
        credits: {
          enabled: false,
        },

        title: {
          text: "",
        },

        pane: {
          startAngle: -90,
          endAngle: 90,
          background: null,
          //center: ['50%', '55%'],
          //size: '100%'
        },

        // the value axis
        yAxis: {
          min: 0,
          max: 100,
          tickPixelInterval: 100,
          tickPosition: "inside",
          tickColor: "#FFFFFF",
          tickLength: 30,
          tickWidth: 0,
          minorTickInterval: null,
          labels: {
            enabled: false,
            distance: 20,
            style: {
              fontSize: "14px",
            },
          },
          plotBands: [
            {
              from: 0,
              to: 59,
              color: "#E51610", // green
              thickness: 50,
            },
            {
              from: 59,
              to: 90,
              color: "#FBB040", // yellow
              thickness: 50,
            },
            {
              from: 90,
              to: 100,
              color: "#216957", // red
              thickness: 50,
            },
          ],
        },

        series: [
          {
            name: "ร้อยละของการใช้งปม.",
            data: [76.06],
            tooltip: {
              valueSuffix: " ฿",
            },
            dataLabels: {
              enabled: false,
              format: "{y} ฿",
              borderWidth: 0,
              color: "#FFDD40",
              style: {
                fontSize: "16px",
              },
            },
            dial: {
              radius: "80%",
              backgroundColor: "#464647",
              baseWidth: 12,
              baseLength: "0%",
              rearLength: "0%",
            },
            pivot: {
              backgroundColor: "#464647",
              radius: 6,
            },
          },
        ],
      },
      solidgaugeChartOptions: {
        chart: {
          type: "solidgauge",
          width: 300,
          backgroundColor: "#F5F5F5",
        },
        credits: {
          enabled: false,
        },

        title: {
          text: "",
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "16px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for IRTC
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: Highcharts.color("#F9BB43")
                .setOpacity(0.3)
                .get(),
              borderWidth: 0,
            },
            {
              // Track for Collaborative Research
              outerRadius: "87%",
              innerRadius: "63%",
              backgroundColor: Highcharts.color("#F9BB43")
                .setOpacity(0.3)
                .get(),
              borderWidth: 0,
            },
            {
              // Track for STI Business Incubation
              outerRadius: "62%",
              innerRadius: "38%",
              backgroundColor: Highcharts.color("#F9BB43")
                .setOpacity(0.3)
                .get(),
              borderWidth: 0,
            },
            {
              // Track for Service Platform
              outerRadius: "37%",
              innerRadius: "13%",
              backgroundColor: Highcharts.color("#F9BB43")
                .setOpacity(0.3)
                .get(),
              borderWidth: 0,
            },
          ],
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false,
            },
            linecap: "round",
            stickyTracking: false,
            rounded: true,
            lineWidth: 20,
          },
        },

        series: [
          {
            name: "Service Platform",
            data: [
              {
                color: "#F19782",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
          {
            name: "IRTC",
            data: [
              {
                color: "#F9BB43",
                radius: "87%",
                innerRadius: "63%",
                y: 0,
              },
            ],
          },
          {
            name: "STI Business Incubation",
            data: [
              {
                color: "#F7941D",
                radius: "62%",
                innerRadius: "38%",
                y: 0,
              },
            ],
          },
          {
            name: "Collaborative Research",
            data: [
              {
                color: "#F15A29",
                radius: "37%",
                innerRadius: "13%",
                y: 0,
              },
            ],
          },
        ],
      },
      columnChartOptions: {
        chart: {
          type: "column",
          width: 900,
        },
        colors: [
          {
            linearGradient: perShapeGradient,
            stops: [
              [0, "#FBB040"],
              [1, "#F15A29"],
            ],
          },
          {
            linearGradient: perShapeGradient,
            stops: [
              [0, "#4285F4"],
              [1, "#3B608A"],
            ],
          },
        ],
        title: {
          text: "",
          style: {
            color: "#555",
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          borderWidth: 0,
          backgroundColor: "#FFFFFF",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: "",
          },
          labels: {
            formatter: function () {
              // เอาค่าจากแกน Y มาแปลงเป็น ล้าน
              return this.value / 1000000 + " ล้าน";
            },
          },
        },
        tooltip: {
          shared: false,
          valueSuffix: "฿",
          useHTML: true,
          backgroundColor: null,
          borderWidth: 0,
          shadow: false,
          formatter: function () {
            return `
              <div class="tooltip ">
                <div class="pa-2 font-14 font-w-700 font-ch" style="background-image: linear-gradient(${
                  this.series.color.stops[0][1]
                }, ${this.series.color.stops[1][1]}); color: #fff">
                  ${this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ฿
                </div>
                <div class="pa-2 font-10 card_tooltip font-ch">
                   ${this.key}
                </div>
              </div>
              `;
          },
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.1,
          },
          series: {
            groupPadding: 0.15, // ระยะห่างระหว่างกลุ่มแท่ง
            pointPadding: 0, // ระยะห่างระหว่างแท่ง
          },
        },
        series: [
          {
            name: "งบประมาณที่ได้รับ",
            data: [],
          },
          {
            name: "งบประมาณที่ใช้ไป",
            data: [],
          },
        ],
      },
      data: {},
      isShoSsolidgauge: true,
      dialog: false,
    };
  },
  watch: {
    filter: {
      handler: function (val) {
        this.getData();
      },
      deep: true,
    },
    exportExcel: function (val) {
      if (val) {
        this.exportToExcel();
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isGaugeChartOptions = false;
      let res = await this.$apiFire("Dashboard/budget", this.filter);
      if (res) {
        this.data = res;

        this.gaugeChartOptions.series[0].data[0] = parseFloat(this.data.budgetRate);
        this.isGaugeChartOptions = true;

        // set data for graph solidgauge
        this.data.plans.forEach((plan, index) => {
          this.solidgaugeChartOptions.series[index].data[0].y = parseFloat(plan.budgetRate);
        });
       
        // set data for graph column
        this.columnChartOptions.series[0].data = [];
        this.columnChartOptions.series[1].data = [];
        this.columnChartOptions.xAxis.categories = [];

        this.data.regions.forEach((region, index) => {
          this.columnChartOptions.series[0].data.push(
            parseFloat(region.totalBudget)
          );
          this.columnChartOptions.series[1].data.push(
            parseFloat(region.usedBudget)
          );
          // set categories for graph column
          this.columnChartOptions.xAxis.categories.push(region.name);
        });

        this.$forceUpdate();
      }
    },
    showDialog() {
      this.dialog = true;
      this.isShoSsolidgauge = false;
      this.solidgaugeChartOptions.chart.width = 800;
    },
    closeDialog() {
      this.dialog = false;
      this.isShoSsolidgauge = true;
      this.solidgaugeChartOptions.chart.width = 300;
    },
    checkFormatNummber(number) {
      if (number == null) return 0;
      number = parseFloat(number).toFixed(1);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    exportToExcel() {
      console.log("exportToExcel", this.data);
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      // ส่วนหัวข้อ งบประมาณ
      let doc_date = moment().add(543, "year").format("DDMMYYYY");
      const topicRow = ["งบประมาณ", "ข้อมูล ณ วันที่ " + doc_date];
      XLSX.utils.sheet_add_aoa(worksheet, [topicRow], { origin: "A1" });

      let jsonExcelSection1 = [];
      this.data.regions.forEach((region, i) => {
        jsonExcelSection1.push({
          ลำดับ: i + 1,
          ภูมิภาค: region.name,
          ชื่อโครงการหลัก: "ยังไม่ทราบตัวแปร",
          ชื่อแผนงาน: "ทั้งหมด",
          "ร้อยละของการใช้งปม.ทั้งหมด (วันนี้)": "ยังไม่ทราบตัวแปร",
          "งปม.ปี 2566": region.totalBudget,
          "งปม. ที่ใช้ไป": region.usedBudget,
          "งปม. คงเหลือ":
            parseFloat(region.totalBudget) - parseFloat(region.usedBudget),
          จำนวนโครงการและงบประมาณตามแผนงาน: this.data.projectAmount,
          ร้อยละการใช้งบประมาณตามแผนงาน: "",
          ร้อยละการใช้งบประมาณตามภูมิภาค: "",
          การใช้งบประมาณตามภูมิภาค: "",
        });
        this.data.plans.forEach((item, j) => {
          jsonExcelSection1.push({
            ลำดับ: "",
            ภูมิภาค: "",
            ชื่อโครงการหลัก: "",
            ชื่อแผนงาน: item.nameTH,
            "ร้อยละของการใช้งปม.ทั้งหมด (วันนี้)": "",
            "งปม.ปี 2566": item.budgetReceived,
            "งปม. ที่ใช้ไป": "",
            "งปม. คงเหลือ": "",
            จำนวนโครงการและงบประมาณตามแผนงาน: "",
            ร้อยละการใช้งบประมาณตามแผนงาน: item.budgetRate,
            ร้อยละการใช้งบประมาณตามภูมิภาค: "",
            การใช้งบประมาณตามภูมิภาค: "",
          });
        });

        // การใช้งบประมาณตามภูมิภาค
        // jsonExcelSection1.push({
        //   ลำดับ: "",
        //   ภูมิภาค: "",
        //   ชื่อโครงการหลัก: "",
        //   ชื่อแผนงาน: "",
        //   "ร้อยละของการใช้งปม.ทั้งหมด (วันนี้)": "",
        //   "งปม.ปี 2566": "",
        //   "งปม. ที่ใช้ไป": "",
        //   "งปม. คงเหลือ": "",
        //   จำนวนโครงการและงบประมาณตามแผนงาน: "",
        //   ร้อยละการใช้งบประมาณตามแผนงาน: "การใช้งบประมาณตามภูมิภาค",
        //   ร้อยละการใช้งบประมาณตามภูมิภาค: this.data.totalBudget,
        // });
      });

      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection1, {
        origin: "A2",
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      let fileName = `budget_dashboard_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      this.$emit("clearExportExcel", false);
    },
  },
};
</script>

<style lang="scss">
.budget {
  .custom_card {
    border-radius: 20px;
    padding: 1rem;
  }

  .gauge_chart {
    .highcharts-container {
      margin-bottom: -11.5rem !important;
      margin-top: -1.5rem;
    }
  }
  .solidgauge_chart {
    .highcharts-container {
      margin-bottom: -3.5rem !important;
      margin-top: -4.5rem;
      border-radius: 100%;
    }
  }
  .con_solidgauge {
    background: #f5f5f5;
    opacity: 0.5;
    border-radius: 20px;
  }
  .budget_rate:hover {
    cursor: pointer;
    color: #f15a29;
  }
}
.tooltip {
  // overflow: hidden;
}
.card_tooltip {
  background: #ffffff;
  min-width: 174px;
  border: 1px solid #e5e5e5;
  // border-top: 0px solid #e5e5e5;
  // border-bottom-left-radius: 10px solid #e5e5e5;
  // border-bottom-right-radius: 10px solid #e5e5e5;
}
</style>
